import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';

const navContainer = {
  display: 'flex',
  gap: '2rem',
  padding: '1rem 2rem',
  borderBottom: '1px solid #eee',
  background: '#fff',
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  justifyContent: 'center',
  flexWrap: 'wrap',
};

const linkBase = {
  position: 'relative',
  textDecoration: 'none',
  color: '#333',
  fontWeight: '500',
  paddingBottom: '4px',
};

const activeStyle = {
  color: '#0077ff',
  fontWeight: '700',
};

const underlineStyle = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  height: '2px',
  background: '#0077ff',
  borderRadius: '1px',
};

const Navbar = () => (
  <nav style={navContainer}>
    {['/', '/projects', '/contact'].map((path) => {
      const label = path === '/' ? 'Home' : path.slice(1).charAt(0).toUpperCase() + path.slice(2);
      return (
        <NavLink
          key={path}
          to={path}
          style={({ isActive }) => ({
            ...linkBase,
            ...(isActive ? activeStyle : {}),
          })}
        >
          {({ isActive }) => (
            <motion.div
              whileHover={{ scale: 1.05 }}
              transition={{ type: 'spring', stiffness: 300 }}
              style={{ display: 'inline-block' }}
            >
              {label}
              <motion.div
                layoutId="underline"
                style={{
                  ...underlineStyle,
                  width: isActive ? '100%' : '0%',
                }}
                animate={{ width: isActive ? '100%' : '0%' }}
                transition={{ duration: 0.3 }}
              />
            </motion.div>
          )}
        </NavLink>
      );
    })}
  </nav>
);

export default Navbar;
